var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCalendarSolid = function SvgCalendarSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#141414",
    d: "M16.25 2.5h-1.875v-.625a.625.625 0 1 0-1.25 0V2.5h-6.25v-.625a.625.625 0 0 0-1.25 0V2.5H3.75A1.25 1.25 0 0 0 2.5 3.75v12.5a1.25 1.25 0 0 0 1.25 1.25h12.5a1.25 1.25 0 0 0 1.25-1.25V3.75a1.25 1.25 0 0 0-1.25-1.25M6.563 14.375a.938.938 0 1 1 0-1.875.938.938 0 0 1 0 1.875m3.437 0a.938.938 0 1 1 0-1.875.938.938 0 0 1 0 1.875m0-3.125a.938.938 0 1 1 0-1.875.938.938 0 0 1 0 1.875m3.438 3.125a.937.937 0 1 1 0-1.875.937.937 0 0 1 0 1.875m0-3.125a.937.937 0 1 1 0-1.875.937.937 0 0 1 0 1.875m2.812-5H3.75v-2.5h1.875v.625a.625.625 0 0 0 1.25 0V3.75h6.25v.625a.625.625 0 1 0 1.25 0V3.75h1.875z"
  })));
};
export default SvgCalendarSolid;